import { FormElement } from '../../form-element.model';
import { FormElementHbaProfileDataField } from './form-element-hba-profile-data-field.model';

export class FormElementHbaProfileData extends FormElement {
  public MemberTypeCode: FormElementHbaProfileDataField;
  public MembershipStatusCode: FormElementHbaProfileDataField;
  public NumberOfUnitsCode: FormElementHbaProfileDataField;
  public DollarVolumeCode: FormElementHbaProfileDataField;
  public PrimaryBusActivityCode: FormElementHbaProfileDataField;
  public SecondaryBusActivityCode: FormElementHbaProfileDataField;
  public TertiaryBusActivityCode: FormElementHbaProfileDataField;

  public constructor() {
    super();

    this.initialize();
  }

  public initialize(): void {
    this.ElementTypeId = 14;

    this.MemberTypeCode = new FormElementHbaProfileDataField();
    this.MembershipStatusCode = new FormElementHbaProfileDataField();
    this.NumberOfUnitsCode = new FormElementHbaProfileDataField();
    this.DollarVolumeCode = new FormElementHbaProfileDataField();
    this.PrimaryBusActivityCode = new FormElementHbaProfileDataField();
    this.SecondaryBusActivityCode = new FormElementHbaProfileDataField();
    this.TertiaryBusActivityCode = new FormElementHbaProfileDataField();

    this.MemberTypeCode.LabelText = 'Member Type';
    this.MembershipStatusCode.LabelText = 'Membership Status';
    this.NumberOfUnitsCode.LabelText = 'Number of Units';
    this.DollarVolumeCode.LabelText = 'Dollar Volume';
    this.PrimaryBusActivityCode.LabelText = 'Primary Business Activity';
    this.SecondaryBusActivityCode.LabelText = 'Secondary Business Activity';
    this.TertiaryBusActivityCode.LabelText = 'Tertiary Business Activity';
  }
}
